import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "16",
      cy: "16",
      r: "15.5",
      fill: "#F5FAFF",
      stroke: "#83B9FF",
      "stroke-dasharray": "4 4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "M16 22.6a6.667 6.667 0 1 0 0-13.333A6.667 6.667 0 0 0 16 22.6",
      opacity: ".4"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#4893F4",
      d: "m17.506 16-1.006-.353v-2.26h.24c.54 0 .98.473.98 1.053 0 .273.227.5.5.5s.5-.227.5-.5c0-1.133-.887-2.053-1.98-2.053h-.24V12c0-.273-.227-.5-.5-.5-.274 0-.5.227-.5.5v.387h-.434c-.986 0-1.793.833-1.793 1.853 0 1.193.694 1.573 1.22 1.76l1.007.353v2.254h-.24c-.54 0-.98-.474-.98-1.054 0-.273-.227-.5-.5-.5s-.5.227-.5.5c0 1.134.886 2.054 1.98 2.054h.24V20c0 .273.226.5.5.5.273 0 .5-.227.5-.5v-.387h.433c.987 0 1.794-.833 1.794-1.853-.007-1.2-.7-1.58-1.22-1.76Zm-2.68-.94c-.34-.12-.546-.233-.546-.813 0-.474.353-.854.793-.854h.434V15.3zm2.107 3.553H16.5v-1.906l.673.233c.34.12.547.233.547.813 0 .474-.354.86-.787.86"
    }, null, -1)
  ]))]))
}
export default { render: render }